export default __webpack_public_path__ + "7cc4e5e837fa576220010549ca6d849d.png";